import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormArray, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslationService, UrlPipe, I18nModule } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Router, RouterLink } from '@angular/router';
import { tap } from 'rxjs/operators';
import { MasterData } from 'src/app/core/model/master-data.model';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { CustomProfileService } from '../../../core/services/custom-profile.service';
import { WindowRef } from '@spartacus/core';
import { pairwise } from 'rxjs/operators';
import { User } from 'src/app/core/model/users.models';
import { CustomLoginService } from '../../custom-login/custom-login-form/custom-login.service';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, NgFor } from '@angular/common';
import { NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';

@Component({
    selector: 'app-custom-editcontact',
    templateUrl: './custom-editcontact.component.html',
    styleUrls: ['./custom-editcontact.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, FormsModule, ReactiveFormsModule, NgFor, NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, RouterLink, UrlPipe, I18nModule]
})
export class CustomEditcontactComponent implements OnInit {

  @Input() addupdate: boolean;
  @Input() admin: any;
  add: any;
  title: any;
  navigationData: any;
  customer: any;
  enableLoader = true;
  contacts: any;
  errorMessage: any;
  token: any;
  addcontactdetails: any;
  addcontactform: UntypedFormGroup;
  master: any;
  userDataModel:User;
  unit: any;
  newform: any;
  contact: any;
  message = 'false';
  alphamumeric = '^[a-zA-Z0-9]+$';
  disabled = false;
  userid: any;
  usergroup: any;
  userGroupName: any;
  masterDataModel: MasterData;
  role: any ;
  @Output() messageEvent = new EventEmitter<string>();
  loggedinUser: any;
  route: any;
  updatecontact: any;
  error: string;
  isDisabled = false;
  commodityTypes: any = []
  userRoles: any =[];
  roleUser:[];
  dropdownSettings = {};
  selectedCommodity: any = [];
  selectedRole:any =[];
  checkedcommodity: UntypedFormGroup;
  writeAccess: any;
  isCustomerEmulated: boolean;
  isSaveDisabled: boolean;
  constructor(
    public toastService: ToastService,
    private cd: ChangeDetectorRef,
    private userAccountFacade: UserAccountFacade,
    private translation: TranslationService,
    private customProfileService: CustomProfileService,
    private router: Router,private csAgentAuthService:CsAgentAuthService,
    private winRef: WindowRef,private customloginservice:CustomLoginService,
    private customProductService: CustomProductsService, private fb: UntypedFormBuilder) {
      
     }

  ngOnInit(): void {
    this.customloginservice.getASMAcess().subscribe(res=>{
      this.writeAccess = res?.writeAccess;
      this.csAgentAuthService.isCustomerEmulated().subscribe(emulated => {
        this.isCustomerEmulated = emulated;
        if(this.writeAccess==false&& this.isCustomerEmulated == true){
          this.isSaveDisabled = true;
        }else{
          this.isSaveDisabled = false;
        }
      })
    })
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'description',
      itemsShowLimit: 3,
      defaultOpen: false,
    };  
    this.customProductService.getHomeLinkActive(false);
     this.updatecontact = this.customProductService.contactData;
    this.customProfileService.getcontacts(this.usergroup).pipe(tap(_=>console.log(_))).subscribe((data:any) => {
      this.contacts = data.users;      
      const ind = data.users.findIndex(res => res.uid == localStorage.getItem("contactId"))
       this.updatecontact = data.users[ind]
        if(this.updatecontact.commodityType){
          this.commodityTypes =  this.updatecontact.commodityType.map(data => data.id)
       }
       
       if(this.updatecontact.userRole){
        this.userRoles =  this.updatecontact.userRole.map(data => data.code)
         }
        
      if (this.updatecontact === undefined){
        this.navigateToLandingPage();
      }
      this.customProductService.scrollToTop();
      this.userAccountFacade.get().subscribe((data: any) => {
        if (data) {
          if (this.winRef.localStorage.getItem('groupCompanyAdminFlag')) {
            this.admin = JSON.parse(this.winRef.localStorage.getItem('groupCompanyAdminFlag'));
          }
            this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          if (previous !== current) {
                if (current != null) {
                 
                  this.getGroupUser();
                }
              }
            });
          // if (data.roles[0] === 'b2badmingroup') {
          //   this.admin = true;
          //   this.role = 'admin' ;
          // } else {
          //   this.admin = false;
          //   this.role = 'manager' ;
          // }
          if (data.uid === this.updatecontact.uid){
            if (this.admin){
                this.role = 'admin';
            }
        }
          if (this.updatecontact.mobileNumber ){
            this.updatecontact.mobileNumber = this.updatecontact.mobileNumber.replace(' ', '');
        }
        if (this.updatecontact.alternateNumber){
          this.updatecontact.alternateNumber = this.updatecontact.alternateNumber.replace(' ', '');
        }
          this.userid = data.uid;
          this.usergroup = this.customProfileService.getGroupCompany();
        // this.usergroup = data.orgUnit.uid;
          this.getGroupUser();
        }
      });
      this.addcontactform = this.fb.group({
        titleCode: [{ value: !this.addupdate ? this.updatecontact.titleCode : '', disabled: !this.admin }],
        firstName: [{ value: !this.addupdate ? this.updatecontact.firstName : '', disabled: !this.admin },
        [Validators.required]],
        lastName: [{ value: !this.addupdate ? this.updatecontact.lastName : '', disabled: !this.admin },
        [Validators.required]],
        email: [{ value: !this.addupdate ? this.updatecontact.uid : '', disabled: true }, [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}')]],
        mobileNumber: [{ value: !this.addupdate ? this.updatecontact.mobileNumber : '', disabled: !this.admin },
        Validators.pattern('^[+0-9]{0,15}$')],
        alternateNumber: [{ value: !this.addupdate ? this.updatecontact.alternateNumber : '', disabled: !this.admin }, Validators.pattern('^[+0-9]{0,15}$') ],
        department: [{ value: !this.addupdate ? this.updatecontact.department : '', disabled: !this.admin }, ],
        jobTitle: [{ value: !this.addupdate ? this.updatecontact.jobTitle : '', disabled: !this.admin }, ],
        modeOfContact: [{ value: !this.addupdate ? this.updatecontact.modeOfContact : '', disabled: !this.admin }],
        role: [{ value: !this.addupdate ? this.role : '', disabled: !this.admin }],
        userRole: [{ value: this.updatecontact.userRole, disabled: true }],
        accessIndicator: [{ value: !this.addupdate ? this.updatecontact.accessIndicator?.toString(): 'false', disabled: !this.admin }],
        commodityType: [{value:  this.updatecontact.commodityType, disabled: true }],
        
        // accessIndicator: [{ value: this.updatecontact.accessIndicator.toString(), disabled: !this.admin }],

        uid: [{ value: !this.addupdate ? this.usergroup : this.usergroup , disabled: !this.admin }],
        // name: [{ value: !this.addupdate ? this.updatecontact.orgUnit.name : this.userGroupName , disabled: !this.admin }],
        linkedInProfile: [{ value: !this.addupdate ? this.updatecontact.linkedInProfile : '', disabled: !this.admin }]
      });
      this.translation.translate('breadcrumb.editContact.pageTitle').subscribe(res => {
          this.title = res;
        });
      this.translation.translate('breadcrumb.editContact.breadcrumb').subscribe(res => {
          this.navigationData = res;
        });
      this.translation.translate('home.toastErrorMessages.dataSaved').subscribe(res => {
          this.error = res;
        });
    });
  }
  // onItemSelect(item: any) {
  //   this.selectedCommodity.push(item)
  // }
  // onSelectAll(items: any) {
  //   console.log(items);
  // }
  selectCommodity(item:any, selected:boolean){
    if(this.updatecontact.commodityType){
    if(!selected){  
      this.updatecontact.commodityType.push(item)
      }
      else{
        const ind = this.updatecontact.commodityType.findIndex(itm => itm.id == item.id)
        this.updatecontact.commodityType.splice(ind,1)
      }
    }else{
      if(!selected){
       this.selectedCommodity.push(item)
      }else{
        const ind = this.selectedCommodity.findIndex(itm => itm.id == item.id)
        this.selectedCommodity.splice(ind,1)     
      }
    }
  }
  selectUserRole(item:any, selected:boolean){
    if(this.updatecontact.userRole){
    if(!selected){ 
      this.updatecontact.userRole.push(item)  
      }else{
        const ind = this.updatecontact.userRole.findIndex(itm => itm.code == item.code)
        this.updatecontact.userRole.splice(ind,1)
      }
   }
   else{
    if(!selected){
      this.selectedRole.push(item)
    }else{
      const ind = this.selectedRole.findIndex(itm => itm.code == item.code)
      this.selectedRole.splice(ind,1)
    }
  }
 }

  createcontact(i): any {
    
    this.isDisabled = true;
    this.cd.detectChanges();
    this.addcontactform.value.email = this.updatecontact.uid;
    // this.addcontactform.value.department 
    // this.addcontactform.value.alternateNumber 

    this.newform = this.addcontactform.value;
    // this.newform.alternateNumber = null;
    // this.newform.department = null;
    // this.newform.modeOfContact = null;
    // const checkArray: FormArray = this.checkedcommodity.get('checkArray') as FormArray;
    this.newform.unit = { uid: this.addcontactform.value.uid };
    this.newform.commodityType = this.updatecontact.commodityType ? this.updatecontact.commodityType : this.selectedCommodity;
    this.newform.userRole = this.updatecontact.userRole ? this.updatecontact.userRole : this.selectedRole;
    delete this.newform.uid;
    const role = this.addcontactform.value.role;
    delete this.newform.role;
    this.newform.role = role;
    if (this.addupdate) {
      this.customProfileService.createUpdateUser(this.usergroup, this.newform).subscribe(res => {
          this.toastService.show(this.error);
          this.enableLoader = false;
          this.navigateToLandingPage();
          this.cd.detectChanges();
        }, (error) => {
          this.errorMessage = error;
          this.enableLoader = false;
          // throw error;   //You can also throw the error to a global error handler
        });
    } else {      
      const queryString = this.updatecontact.uid + '?fields=DEFAULT';
      this.customProfileService.updateUser(this.usergroup, this.newform, queryString).subscribe(res => {
          this.toastService.show(this.error);
          this.enableLoader = false;
          this.navigateToLandingPage();
          this.cd.detectChanges();
        }, (error) => {
          this.errorMessage = error;
          this.enableLoader = false;
        });
    }
  }

  sendMessage(): any {
    this.messageEvent.emit(this.message);
  }
  navigateToLandingPage(): any {
    this.router.navigate(['/companies/myCompany/contacts/detail']);
  }
  getGroupUser(): any{
    this.customProfileService.getGroupUser(this.usergroup).subscribe((res: MasterData) => {
      if (res) {
        this.enableLoader = false;
        this.master = res;
        this.masterDataModel = res;
        this.cd.detectChanges();
      }
    }, (error) => {
      this.errorMessage = error;
      this.enableLoader = false;
    });
  }
  
}
